import autoBind from 'auto-bind'

import { AppApiBase } from 'api/core/AppApiBase'
import { paymentHeaders } from 'utils'

export type BalanceInfo = {
  balance: number
}

export type MakePurchase = {
  amount: number
  promo_code?: string
}

export class CreditsApi {
  constructor(protected api: AppApiBase) {
    autoBind(this)
  }

  getBalance() {
    return this.api.get<BalanceInfo>('/balances/balance')
  }

  makePurchase(body: MakePurchase) {
    return this.api.post<{ redirect_url: string }>(`/transactions/purchase_credits`, body, { headers: paymentHeaders() })
  }
}
